import { IntlProviderWithMessages, useLocale } from '@databases/intl';
import { perf } from '@databases/logs/performance';
import React from 'react';

import AppWithQueryParamContext from './app-with-query-param-context.tsx';

const AppWithLocale = () => {
  const locale = useLocale();

  perf.timeLog('app-initialization', 'app-with-locale');

  return (
    <IntlProviderWithMessages locale={locale}>
      <AppWithQueryParamContext />
    </IntlProviderWithMessages>
  );
};

export default AppWithLocale;
